import { ForgetPasswordComponent } from './forget-password/forget-password.component';

export const CONTAINERS = [ForgetPasswordComponent];

export * from './forget-password/forget-password.component';
